import { styled } from '@mui/material';
import { ReactComponent as EditContractIcon } from '../../assets/icons/EditContract.svg';

export const UPEditActionIcon = styled(EditContractIcon)(() => ({
  '&&': {
    width: '36px',
    height: '36px',
  },
  '&& path': {
    stroke: 'none',
  },
}));
